<template>
  <div>
    <!-- 联系我们 -->
    <div class="ContactUsBg">
      <div class="ContactUs">
        <p>联系我们，我们将竭诚为您服务</p>
        <el-button class="consultBtn" @click="dialogFormVisible = true">
          立即咨询
        </el-button>
      </div>
    </div>

    <el-dialog title="联系我们" :visible.sync="dialogFormVisible">
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item label="您的姓名" prop="nickName">
          <el-input v-model="form.nickName"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="form.email"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="phone">
          <el-input v-model="form.phone"></el-input>
        </el-form-item>
        <el-form-item label="您的需求" prop="requirements">
          <el-input type="textarea" v-model="form.requirements" placeholder="您有什么样的需求，希望我们的产品为您解决什么问题 ?"></el-input>
        </el-form-item>
        <el-button class="ContactUsSubmit" @click="Submit('form')">
          确 定
        </el-button>
      </el-form>

    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import HeadLine from "../components/content/headline/HeadLine";
import { contactAdd } from "../network/index";

export default {
  name: "News",
  components: { HeadLine },
  data() {
    return {
      dialogFormVisible: false,
      form: {
        nickName: "",
        email: "",
        phone: "",
        requirements: "",
      },
      rules: {
        nickName: [
          {
            required: true,
            message: "请输入您的姓名",
            trigger: "blur",
          },
          {
            min: 2,
            max: 20,
            message: "姓名长度应在 2 到 20 个字符之间",
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: "请输入邮箱",
            trigger: "blur",
          },
          {
            type: "email",
            message: "请输入正确的邮箱格式",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入电话",
            trigger: "blur",
          },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        requirements: [
          {
            required: true,
            message: "请输入您的需求",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
  },
  methods: {

    // 参考木鸢前台意见反馈
     Submit(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
         const saveForm = {
            nickName: this.form.nickName,
            email: this.form.email,
            phone: this.form.phone,
            requirements: this.form.requirements,
          };
          // 提交表单接口
          contactAdd(saveForm).then(res => {
            if (res.code === 200) {
              // 提交成功, 关闭窗口, 刷新列表
              this.$message({ 
                message: "提交成功", 
                type: "success", 
                duration: 2000 
              });
              this.dialogFormVisible = false;
              this.$nextTick(() => {
                this.$refs[form].resetFields();
              });
            } 
          })

        } else {
          this.$message({
            type: "error",
            message: "添加失败"
          });
        }
      })
    },
  },
};
</script>

<style scoped>
@import "../styles/base.css";
@import "../styles/index.css";
input[type="text"] {
  border: 1px solid #dcdfe6 !important;
}
/deep/ .el-dialog {
  border-radius: 6px 6px 0 0;
  width:518px;
}
/deep/ .el-dialog__header {
  background: url("../assets/img/index/ContactUstopbg.jpg");
  height: 99px;
  text-align: center;
  padding: 0;
  line-height: 99px;
  border-radius: 6px 6px 0 0;
}
/deep/ .el-dialog__title {
  font-size: 28px;
  color: #fff;
}
/deep/ .el-icon-close:before {
  color: #fff;
  font-size: 20px;
}
/deep/ .el-dialog__body {
  background: #f7f7f7;
  padding: 30px 40px;
}
/deep/ .el-form-item__label::before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}
/deep/ .el-form-item{
  margin-bottom: 10px;
}
.ContactUsSubmit{
  background: #f45909;
  color: #FFF;
  font-size: 18px;
  width: 100%;
  border: none;
  margin-top: 50px;
  height: 46px;
  border-radius: 2px;
}
@media only screen and (max-width:767px) {
  /deep/ .el-dialog {
  width:90%;
}
/deep/ .el-dialog__header {
  height: 60px;
  line-height: 60px;
  border-radius: 6px 6px 0 0;
}
/deep/ .el-dialog__title {
  font-size: 20px;
}
/deep/ .el-icon-close:before {
  font-size: 24px;
}
/deep/ .el-dialog__body {
  padding: 15px 20px;
}

/deep/ .el-form-item{
  margin-bottom: 5px;
}
.ContactUsSubmit{
  background: #f45909;
  font-size: 14px;
  margin-top: 20px;
  height: 40px;
  border-radius: 2px;
}

}
</style>



// WEBPACK FOOTER //
// src/components/TellUs.vue